import * as lockIcon from '@nordhealth/icons/lib/assets/navigation-toggle-lock.js'
import * as unlockIcon from '@nordhealth/icons/lib/assets/navigation-toggle.js'
import { html, LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'
import { classMap } from 'lit/directives/class-map.js'
import { ref } from 'lit/directives/ref.js'

import { DirectionController } from '../common/controllers/DirectionController.js'
import { FocusableMixin } from '../common/mixins/FocusableMixin.js'
import componentStyle from '../common/styles/Component.css'

import Icon from '../icon/Icon.js'
import { LocalizeController } from '../localization/LocalizeController.js'
import style from './NavToggle.css'

import '../button/Button.js'
import '../visually-hidden/VisuallyHidden.js'

Icon.registerIcon(unlockIcon)
Icon.registerIcon(lockIcon)

/**
 * Nav toggle is meant for hiding and showing the primary navigation.
 * This component is used internally in the Layout component, but can also be
 * used separate to further customize the behavior.
 *
 * @status ready
 * @category action
 *
 * @localization label - Accessible label for the nav toggle button.
 */
@customElement('nord-nav-toggle')
export default class NavToggle extends FocusableMixin(LitElement) {
  static styles = [componentStyle, style]

  private direction = new DirectionController(this)
  private localization = new LocalizeController<'nord-nav-toggle'>(this)

  render() {
    return html`
      <nord-button variant="plain" ${ref(this.focusableRef)} class=${classMap({ 'is-rtl': this.direction.isRTL })}>
        <nord-visually-hidden>${this.localization.term('label')}</nord-visually-hidden>
        <nord-icon size="m" name=${unlockIcon.title}></nord-icon>
        <nord-icon size="m" name=${lockIcon.title}></nord-icon>
      </nord-button>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-nav-toggle': NavToggle
  }
}
